import classNames from 'classnames';
import { ChangeEvent, DragEvent, FC } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import { formatImagePath } from 'src/utils/formatter';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';

interface IProps {
  fileName?: string;
  fileLinkUrl?: string;
  onUpload: (file: File) => void;
  onUnlink: (file: File) => void;
  error?: string | null;
  wrapperClassName?: string;
}

export const TextFileUploader: FC<IProps> = ({ fileName, fileLinkUrl, wrapperClassName, error, onUpload, onUnlink }): JSX.Element => {
  const handleFileClickUpload = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    onUpload(e.target.files[0]);
  };

  const handleFileDragUpload = (e: DragEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!e.dataTransfer.files) return;
    onUpload(e.dataTransfer.files[0]);
  };

  const handleFileUnlink = () => {
    onUnlink(new File([], ''));
  };

  const handleFileClick = () => {
    if (!fileLinkUrl) return;
    window.open(fileLinkUrl, '_blank');
  };

  return (
    <div className={classNames('file-uploader-container', wrapperClassName, { 'border-red': error })}>
      <input
        type="file"
        accept="application/pdf"
        className="w-100 h-100 opacity-0 cursor-pointer"
        onDrop={handleFileDragUpload}
        onChange={handleFileClickUpload}
      />
      {fileName ? (
        <div className="file-uploader-container__content">
          <img
            src={formatImagePath(`${Icons.Pdf}.svg`)}
            alt="Drag"
            className="cursor-pointer"
            style={{ width: 124, height: 174 }}
            onClick={handleFileClick}
          />
          <div className="file-uploader-container__content-reset-icon" onClick={handleFileUnlink}>
            <Icon name={Icons.Close} size={10} className="color-gray2" />
          </div>
          <p className="family-regular text-size-14 text-elipsis mt-2">{fileName}</p>
        </div>
      ) : (
        <div className="file-uploader-container__placeholder">
          <img src={formatImagePath(`${Icons.FileDrag}.svg`)} alt="Drag" style={{ width: 120, height: 80 }} />
          <p className="family-regular text-size-14 mt-4">{localeStore.t('drag_and_drop_or_click_here_to_select_file')}</p>
          <p className="family-medium text-size-10 color-gray2 text-uppercase letter-spacing-12 mt-2">pdf</p>
          {error ? <p className="family-regular text-size-14 color-red mt-5">{localeStore.t(error)}</p> : null}
        </div>
      )}
    </div>
  );
};
